import React, { useEffect, useRef } from 'react';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'dotlottie-player': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & {
        src?: string;
        background?: string;
        speed?: string | number;
        loop?: boolean;
        autoplay?: boolean;
        style?: React.CSSProperties;
      };
    }
  }
}

interface LottiePlayerProps {
  src: string;
  className?: string;
  style?: React.CSSProperties;
  speed?: number;
  background?: string;
  loop?: boolean;
  autoplay?: boolean;
}

export function LottiePlayer({
  src,
  className,
  style,
  speed = 1,
  background = "transparent",
  loop = true,
  autoplay = true,
}: LottiePlayerProps) {
  return (
    <dotlottie-player
      src={src}
      background={background}
      speed={speed}
      loop={loop}
      autoplay={autoplay}
      style={style}
      className={className}
    />
  );
} 